

// firebase.js
import firebase from "firebase/compat/app";
import "firebase/compat/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCPnfjwtjPII2ifcxmigvHRO12QNuPQJ5A",
  authDomain: "eattendance-2f217.firebaseapp.com",
  projectId: "eattendance-2f217",
  storageBucket: "eattendance-2f217.appspot.com", // FIXED ❗
  messagingSenderId: "123162067351",
  appId: "1:123162067351:web:0d72390c8174496bc904d2",
};

firebase.initializeApp(firebaseConfig);

let messaging = null;
try {
  messaging = firebase.messaging();
} catch (err) {
  console.log("Messaging not supported", err);
}

export const requestForToken = async () => {
  try {
    const vapid = process.env.REACT_APP_VAPID_KEY;

    if (!vapid) {
      console.error("❌ Missing REACT_APP_VAPID_KEY in .env");
      return null;
    }

    const currentToken = await messaging.getToken({
      vapidKey: vapid,
    });

    if (currentToken) {
      console.log("FCM Token:", currentToken);
      localStorage.setItem("fcm_token", currentToken);
      return currentToken;
    } else {
      console.warn("No registration token available.");
      return null;
    }
  } catch (error) {
    console.error("❌ FCM token error:", error);
    return null;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    messaging.onMessage((payload) => {
      resolve(payload);
    });
  });

export default messaging;
